/* eslint-disable jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */
import React from 'react';
import { Button, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  cellDateOperation,
  cellNumOperation,
  cellOperation,
  headerDoubleRowOperation,
  headerOperation,
} from '../../../helpers/tables';
import { API, BASE_URL } from '../../../CONST';
import { fileDownload } from '../../../helpers/helpers';

import FormSection from '../../layout/FormSection';
import BaseTable from '../../shared/BaseTable';

const CorredorGarantiaDetailMovimientos = ({ policy, loginIdToken }) => {
  if (policy === null) return null;

  const { movimientos } = policy;
  const emittedMovimientos = movimientos.filter((m) => m.emitido);

  const columns = [
    {
      Header: headerOperation('Endoso'),
      id: 'movimiento',
      accessor: (i) => cellOperation(`${i.secuencia_endoso} - ${i.tipo_endoso.descripcion}`),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Emisión'),
      id: 'emision',
      accessor: (i) => cellDateOperation(i.emision),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Inicio', 'Cobertura'),
      id: 'inicio-vigencia-endoso',
      accessor: (i) => cellDateOperation(i.inicio_endoso),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Fin', 'Cobertura'),
      id: 'termino-vigencia',
      accessor: (i) => cellDateOperation(i.termino_vigencia),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Moneda'),
      id: 'moneda',
      accessor: () => cellOperation(policy.base.moneda_asegurada.nombre_corto),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Monto', 'Garantizado'),
      id: 'monto-garantizado',
      accessor: (i) => cellNumOperation(i.cambio_cobertura_amt),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Prima', 'Neta'),
      id: 'prima',
      accessor: (i) => cellNumOperation(i.cambio_prima_neta_amt, 'float'),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('% Comisión'),
      id: 'comision_pct',
      accessor: (i) => cellNumOperation(i.cambio_comision_pct, 'float'),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Comisión'),
      id: 'comision',
      accessor: (i) => cellNumOperation((i.cambio_comision_pct * i.cambio_prima_neta_amt) / 100, 'float'),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Acciones'),
      id: 'acciones',
      accessor: (i) =>
        cellOperation(
          <div
            style={{
              padding: '0 25%',
            }}
          >
            <Button
              className="form-values download"
              onClick={() =>
                fileDownload(
                  `${BASE_URL}${API.garantiaIntermediario}/${policy.id}/download-endoso/?endoso=${i.id}`,
                  loginIdToken,
                )
              }
            >
              <FontAwesomeIcon icon={faDownload} />
            </Button>
          </div>,
        ),
      filterable: false,
      sortable: false,
    },
  ];

  return (
    <Col md={{ offset: 2, size: 8 }}>
      <FormSection title="Resumen Movimientos">
        <BaseTable columns={columns} data={emittedMovimientos} />
      </FormSection>
    </Col>
  );
};

CorredorGarantiaDetailMovimientos.propTypes = {
  policy: PropTypes.shape({
    id: PropTypes.number,
    base: PropTypes.object,
    movimientos: PropTypes.arrayOf(PropTypes.object).isRequired,
  }),
  loginIdToken: PropTypes.string.isRequired,
};

CorredorGarantiaDetailMovimientos.defaultProps = {
  policy: null,
};

const mapStateToProps = (state) => ({
  loginIdToken: state.login.id_token,
});

export default connect(mapStateToProps)(CorredorGarantiaDetailMovimientos);
